<template>
  <nav class="LoginDropdown">
    <a v-for="entry in entries"
      :key="entry.title"
      :href="entry.url"
      class="entry"
    >
      {{ entry.title }}
    </a>
  </nav>
</template>

<script>
export default {
  props: {
    entries: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.LoginDropdown {
  background-color: var(--bg-color-white);
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  padding: 0.4rem 0;
}
.entry {
  display: block;
  min-width: 12rem;
  padding: var(--spacing-2) var(--spacing-7);
}
.entry + .entry {
  border-top: thin solid var(--hairline-color);
}
.entry:hover {
  font-weight: 500;
  background-color: var(--brand-color);
  color: white;
}
</style>
